import React from 'react';
import PropTypes from 'prop-types';
import { adopt } from 'react-adopt';
import { Mutation } from '@apollo/react-components';
import gql from 'graphql-tag';

import { GlobalConsumer } from 'site/context';
import ForgotPasswordPage from './forgot-password-page';

const REQUEST_PASSWORD_RESET = gql`
    mutation RequestPasswordReset($email: String!) {
        requestPasswordReset(email: $email)
    }
`;

/* eslint-disable */
const ForgotPasswordState = adopt(
    {
        global: <GlobalConsumer />,
        requestPasswordReset: ({ render }) => (
            <Mutation mutation={REQUEST_PASSWORD_RESET}>{render}</Mutation>
        ),
    },
    ({ context, global, requestPasswordReset }) => ({
        ...context,
        error: requestPasswordReset.error,
        loading: requestPasswordReset.loading,
        requestPasswordReset,
        showFlash: global.showFlash,
    })
);
/* eslint-enable */

const ForgotPasswordContainer = ({ history }) => (
    <ForgotPasswordState>
        {({ error, loading, requestPasswordReset, showFlash }) => {
            if (error) throw error;
            if (loading) return null;
            return (
                <ForgotPasswordPage
                    onSubmit={() => history.push('/sign-in')}
                    requestPasswordReset={({ variables }) => requestPasswordReset({ variables })}
                    showFlash={showFlash}
                />
            );
        }}
    </ForgotPasswordState>
);

ForgotPasswordContainer.propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func.isRequired,
    }).isRequired,
};

export default ForgotPasswordContainer;
